export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 120,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('form_label_reviewStatus') || '评审意见',
    field: 'v_reviewStatus',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' }
  },
  {
    title: that.$l('form_label_reviewByName') || '修改人',
    field: 'reviewByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_reviewTime') || '评审时间',
    field: 'reviewTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_reviewDesc') || '意见说明',
    field: 'reviewDesc',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
